import { render, staticRenderFns } from "./OriginChart.vue?vue&type=template&id=4df3c158"
import script from "./OriginChart.vue?vue&type=script&lang=js"
export * from "./OriginChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports